export const routesConfig:any = {
  "Web Basic Access": ["/dashboard","/change-pin","/my-profile"] ,
  "Web Application Festival Owner": ["/dashboard","/FestivalManagement","/change-pin","/my-profile"] ,
  "Web Application Vendors": ["/dashboard","/change-pin","/FestivalManagement","/my-profile"] ,
  "Web Application Administration": [ "/dashboard", "/FestivalOwnerManagement", "/FestivalManagement", "/UserFunctionsManagement","/UserGroupsManagement","/UserManagement", "/FestivalVendorManagement","/change-pin","/my-profile"]
}